import { css } from '@emotion/react'
import { CSSProperties } from 'react'
import { ColorProperties } from '../color'

type BorderTypes = 'thick' | 'medium' | 'thin' | 'none'
type Elevation = 0 | 1 | 2

export interface BorderProps {
	border?: BorderTypes
	borderColor?: CSSProperties['borderColor']
	elevation?: 0 | 1
}

const ShadowConfig: Record<Elevation, string> = {
	0: 'none',
	1: '0px 0px 16px -2px #00000014',
	2: '0px 0px 24px -2px #00000029'
}

const BorderConfig: Record<BorderTypes, string> = {
	thick: '3px',
	medium: '2px',
	thin: '1px',
	none: '0'
}

export const BorderMods = ({ border, elevation, borderColor = ColorProperties.On }: BorderProps) =>
	css([
		border &&
			css`
				border: solid ${BorderConfig[border]} ${borderColor};
			`,
		elevation &&
			css`
				box-shadow: ${ShadowConfig[elevation]};
			`
	])

BorderMods.Thick = BorderMods({ border: 'thick' })
BorderMods.Medium = BorderMods({ border: 'medium' })
BorderMods.Thin = BorderMods({ border: 'thin' })
BorderMods.None = css({ border: 'none', boxShadow: 'none' })
